import React, { useState, useEffect } from "react";
import AdminHeader from "../components/admin/AdminHeader";
import ManageAccounts from "../components/admin/ManageAccounts";
import BlogAdmin from "../components/admin/BlogManagement";
import MessagesAdmin from "../components/admin/Messages";
import AccountSettings from "../components/admin/AccountSettings";
import { useNavigate } from "react-router-dom";
import { AdminAPI } from "../api/api";
import "bootstrap/dist/css/bootstrap.min.css";

export default function Admin() {
  const [activeSection, setActiveSection] = useState("accounts");
  const [user, setUser] = useState(null); // admin autenticado
  const [loading, setLoading] = useState(true); // ⬅️ nuevo estado de carga
  const navigate = useNavigate();

  // Detectar admin autenticado al montar
  useEffect(() => {
    const fetchUser = async () => {
      try {
        
      await new Promise(resolve => setTimeout(resolve, 300)); // 300ms de espera
        const data = await AdminAPI.me(); // endpoint /me que usa la cookie JWT
        setUser(data);
      } catch {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

  // Función para cerrar sesión
  const handleLogout = async () => {
    try {
      await AdminAPI.logout(); // backend elimina la cookie
      setUser(null);
      navigate("/login");
    } catch (err) {
      console.error("Error al cerrar sesión:", err);
    }
  };

  if (loading) return <p className="text-center mt-5">Cargando...</p>;

  if (!user) {
    // si no hay usuario después de cargar, redirige
    navigate("/login");
    return null;
  }

  return (
    <div className="d-flex" style={{ minHeight: "100vh" }}>
      {/* Sidebar */}
      <AdminHeader setActiveSection={setActiveSection} />

      {/* Contenido principal */}
      <main className="flex-grow-1 p-4 bg-light">
        {activeSection === "accounts" && <ManageAccounts />}
        {activeSection === "blog" && <BlogAdmin />}
        {activeSection === "messages" && <MessagesAdmin />}
        {activeSection === "account" && (
          <AccountSettings user={user} onLogout={handleLogout} />
        )}
      </main>
    </div>
  );
}
